import * as Dialog from "@radix-ui/react-dialog";
import type { ReactNode } from "react";
import { cx } from "@/shared/lib/cx";

export interface ModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Nome accessibile del dialogo; visivamente nascosto, il titolo visibile lo mette ModalShell. */
  title: string;
  size?: "md" | "lg";
  className?: string;
  /** Id del nodo DOM del dialogo: solo per chi lo cerca per id (es. `#terms-modal` del legacy). */
  id?: string;
  children: ReactNode;
}

/** Stesso markup e classi del Modal legacy; focus trap, Escape, click fuori e aria li fa Radix. */
export function Modal({ open, onOpenChange, title, size = "md", className, id, children }: ModalProps) {
  const container =
    typeof document === "undefined" ? undefined : (document.getElementById("modal-root") ?? undefined);
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal container={container}>
        <Dialog.Overlay className="modal modal-open as-modal-backdrop dw-modal-backdrop">
          <Dialog.Content
            id={id}
            className={cx(
              "modal-box modal-dialog dw-modal-dialog border border-base-300 bg-base-100 p-0 shadow-overlay",
              size === "lg" && "modal-lg max-w-4xl",
              className,
            )}
            aria-describedby={undefined}
          >
            <Dialog.Title className="sr-only">{title}</Dialog.Title>
            {children}
          </Dialog.Content>
        </Dialog.Overlay>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
